export default {
    appraisal: 'Appraisal',
    completed: 'Completed',
    processing: 'Awaiting appraisal',
    vAuto: {
        helperMessage: 'You need to submit the appraisal to vAuto to get the vehicle data',
        submit: 'Submit to vAuto',
    },
};
